import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import { loading, toast } from '@/shared/utils/UIHelper'
import axios from 'axios'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import {mask} from 'vue-the-mask'
import datepicker from 'vuejs-datepicker'

export default {
  components: {HeadDetailsGama, datepicker},
  props: ['data'],
  name: 'Typeaddressenterprise',
  data () {
    return {
      urlApiCep: 'https://viacep.com.br/ws/',
      dataEnumType: [],
      dateInicio: null,
      datePrevisao: null
    }
  },
  directives: {mask},
  mounted () {
    this.getEnumType()
  },
  methods: {
    getCepApi () {
      loading.push()
      axios.get(this.urlApiCep + this.data.cep + '/json')
        .then(Response => {
          this.data.bairro = Response.data.bairro
          this.data.endereco = Response.data.logradouro
          this.data.cidade.nome = Response.data.localidade
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    save () {
      loading.push()
      if (this.data.dataInicioObra <= this.data.dataPrevisaoObra) {
        EnterpriseRepository.Update(this.data)
          .then(Response => {
            toast.success('Empreendimento alterado com sucesso!')
            loading.pop()
          })
          .catch(Error => {
            toast.danger(Error)
            loading.pop()
          })
      } else {
        toast.warning('Data Previsão não pode ser menor que Data Inicial da Obra!!')
        loading.pop()
      }
    },
    getEnumType () {
      loading.push()
      EnterpriseRepository.GetEnumType()
        .then(Response => {
          this.dataEnumType = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getDescricaoEnum (value) {
      console.log()
      if (this.dataEnumType.length > 0) {
        return this.dataEnumType.find((Element) => Element.enum === value).descricao
      } else {
        return ''
      }
    },
    getNotIn (value) {
      return this.dataEnumType.filter((Element) => Element.enum !== value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/typeaddressenterprise/typeaddressenterprise.js